import 'dayjs/locale/lt'

const lt = {
  calendar: {
    sameDay: '[Šiandien] LT',
    nextDay: '[Rytoj] LT',
    nextWeek: 'dddd LT',
    lastDay: '[Vakar] LT',
    lastWeek: '[Praėjusį] dddd LT',
    sameElse: 'L'
  }
}

export default lt
